module.exports = __webpack_public_path__ + "img/Hand_31_05_08.79e9aaa8.png";